export function AshokaChakra({ className = "" }) {
  const spokes = Array.from({ length: 24 }, (_, i) => i * 15);
  return (
    <svg viewBox="0 0 100 100" className={className} fill="none" stroke="currentColor" aria-hidden="true">
      <circle cx="50" cy="50" r="44" strokeWidth="5" />
      <circle cx="50" cy="50" r="7" fill="currentColor" stroke="none" />
      {spokes.map((a) => (
        <line key={a} x1="50" y1="12" x2="50" y2="43" strokeWidth="3" strokeLinecap="round" transform={`rotate(${a} 50 50)`} />
      ))}
    </svg>
  );
}
